import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "row no-gutters border-bottom pt-4 pb-3" };
const _hoisted_2 = {
    key: 0,
    class: "col-lg-6 d-flex pb-2"
};
const _hoisted_3 = { class: "col-lg-6 d-flex pb-2" };
const _hoisted_4 = {
    key: 0,
    class: "font6-responsive mb-0"
};
const _hoisted_5 = {
    key: 1,
    class: "font6-responsive mb-0"
};
const _hoisted_6 = { class: "col-lg-6 d-flex pb-2" };
const _hoisted_7 = { class: "font6-responsive mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.hasExtendedWarrantyMonth) === 36)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                        src: "images/_new_brand/icons/icon_detail_wappen.svg",
                        class: "mr-2",
                        width: "24",
                        height: "24",
                        alt: "Check"
                    }, null, -1),
                    _createElementVNode("p", { class: "font6-responsive mb-0" }, "36 Monate Garantie", -1)
                ]))]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: "images/_new_brand/icons/icon_detail_stars.svg",
                class: "mr-2",
                width: "24",
                height: "24",
                alt: "Check"
            }, null, -1)),
            (((_b = _ctx.currentProduct) === null || _b === void 0 ? void 0 : _b.numericCondition) !== 1000)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Getestet und refurbished "))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, "Unbenutzt & originalverpackt"))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-6 d-flex pb-2" }, [
            _createElementVNode("img", {
                src: "images/_new_brand/icons/icon_detail_lkw.svg",
                class: "mr-2",
                width: "24",
                height: "24",
                alt: "Check"
            }),
            _createElementVNode("p", { class: "font6-responsive mb-0" }, "Kostenlose Lieferung und Rücksendung")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
            _cache[3] || (_cache[3] = _createElementVNode("img", {
                src: " images/_new_brand/icons/icon_detail_mypoints.svg",
                class: "mr-2",
                width: "24",
                height: "24",
                alt: "Check"
            }, null, -1)),
            _createElementVNode("p", _hoisted_7, [
                _createTextVNode(" Mit diesem Artikel " + _toDisplayString(_ctx.myPoints) + " myPOINTS sichern ", 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", {
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: "",
                    class: "strong",
                    "data-original-title": "myPOINTS werden Dir nach Ablauf der Rückgabefrist gutgeschrieben (sofern Du die Bestellung nicht stornierst oder retournierst) und können gegen Gutscheine eingetauscht werden"
                }, [
                    _createElementVNode("img", {
                        src: "/images/_new_brand/icons/icon_fragezeichen_full.svg",
                        width: "18",
                        height: "18",
                        title: "(?)",
                        alt: "(?)",
                        style: { "margin-bottom": "2px" }
                    })
                ], -1))
            ])
        ]),
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"col-lg-6 d-flex pb-2\"><img src=\"images/_new_brand/icons/icon_detail_money.svg\" class=\"mr-2\" width=\"24\" height=\"24\" alt=\"Check\"><p class=\"font6-responsive mb-0\">Rechnungs- und Ratenkauf möglich</p></div><div class=\"col-lg-6 d-flex pb-2\"><img src=\"images/_new_brand/icons/icon_detail_rueckgabe.svg\" class=\"mr-2\" width=\"24\" height=\"24\" alt=\"Check\"><p class=\"font6-responsive mb-0\">30 Tage Rückgaberecht</p></div>", 2))
    ]));
}
